import { render } from "./Ipv4GuestSubnetsTab.vue?vue&type=template&id=56fe525e&scoped=true"
import script from "./Ipv4GuestSubnetsTab.vue?vue&type=script&lang=js"
export * from "./Ipv4GuestSubnetsTab.vue?vue&type=script&lang=js"

import "./Ipv4GuestSubnetsTab.vue?vue&type=style&index=0&id=56fe525e&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56fe525e"]])

export default __exports__